import React from 'react';
import PropTypes from 'prop-types';
import { mobileDetect } from 'rp-gui-guide';
import CourseInfoRow from './CourseInfoRow';
import RaceInfoBlock from './RaceInfoBlock';

const CourseInfoBlock = ({
    raceCardsCourseUrl,
    raceCardsCourseMeetingsUrl,
    courseName,
    going,
    weather,
    stallsPosition,
    races,
}) => (
    <div className="nr-block">
        <a
            className="ui-link ui-link_primary nr-block__courseLink js-popupLink"
            href={mobileDetect.mobile() ?
              raceCardsCourseUrl :
              raceCardsCourseMeetingsUrl}
            key="courseLink"
        >
            {courseName}
        </a>
        <CourseInfoRow title={'Going'} description={going} />
        <CourseInfoRow title={'Weather'} description={weather} />
        <CourseInfoRow title={'Stalls'} description={stallsPosition} />
        {
            races.length ? (
                <span className="nr-block__infoTitle">
                    Non runners:
                </span>
            ) : null
        }
        {races.map(race => <RaceInfoBlock {...race} key={race.raceTime} />)}
    </div>
);

CourseInfoBlock.propTypes = {
    courseName: PropTypes.string.isRequired,
    raceCardsCourseUrl: PropTypes.string.isRequired,
    raceCardsCourseMeetingsUrl: PropTypes.string.isRequired,
    going: PropTypes.string,
    weather: PropTypes.string,
    stallsPosition: PropTypes.string,
    races: PropTypes.arrayOf(PropTypes.shape({
        raceCardUrl: PropTypes.string.isRequired,
        raceTime: PropTypes.string.isRequired,
        horses: PropTypes.array.isRequired,
    })).isRequired,
};

export default CourseInfoBlock;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/CourseInfoBlock.jsx